var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('Toolbar'),_c('TabMenu'),_c('transition',{attrs:{"name":"slide-x-transition","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }